import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Grid,
  Typography,
  Button,
  FormControl,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  AppBar,
  Tabs,
  Tab,
  Radio,
  RadioGroup,
  FormControlLabel,
  Link,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { Cached } from '@material-ui/icons';
import moment from 'moment';
import PaginationInput from '../../models/pagination/PaginationInput';
import { useStyles } from './Styles';
import { 
  fetchAllProjectIdsAPI, 
  fetchStagesForProjectAPI, 
  fetchCampaignsForProjectAPI,
  fetchProjectAnalyticsTabsAPI,
  fetchProjectAnalyticsDataAPI
} from './api';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`analytics-tabpanel-${index}`}
      aria-labelledby={`analytics-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const ProjectAnalytics = () => {
  const classes = useStyles();
  const history = useHistory();
  const [selectedProject, setSelectedProject] = useState('');
  const [selectedStage, setSelectedStage] = useState('');
  const [selectedCampaign, setSelectedCampaign] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [tabValue, setTabValue] = useState(0);
  const [lastSyncTime, setLastSyncTime] = useState(new Date());
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedMaterial, setSelectedMaterial] = useState('23938-5-5462310-A');
  const [viewType, setViewType] = useState('Number');
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCPP, setSelectedCPP] = useState('B.3.2');
  const [selectedProcedure, setSelectedProcedure] = useState('B.4.2');
  const [selectedCycleTime, setSelectedCycleTime] = useState('K-252');

  // State for dropdown options (from separate APIs, not filtered)
  const [projectsList, setProjectsList] = useState([]);
  const [stagesList, setStagesList] = useState([]);
  const [campaignsList, setCampaignsList] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // State for tabs from backend
  const [tabsData, setTabsData] = useState([]);
  const [loadingTabs, setLoadingTabs] = useState(false);
  const [tabFilters, setTabFilters] = useState({}); // Store filter values for each tab
  const [tabTableData, setTabTableData] = useState({}); // Store table data for each tab

  const batchYieldData = [
    {
      campaignBatch: 'TYR12345 / 400682',
      actualProductQuantity: '782',
      expectedProductQuantity: '800',
      uom: 'KG',
      yield: '98.75%',
      batchManufacturingDate: '01-AUG-2024',
      expiryDate: '01-DEC-2026',
      storageCondition: 'Ambient',
      storageLocation: 'Hyderabad, Telangana, India',
    },
    {
      campaignBatch: 'TYR12345 / 400683',
      actualProductQuantity: '739',
      expectedProductQuantity: '750',
      uom: 'KG',
      yield: '98.75%',
      batchManufacturingDate: '01-AUG-2024',
      expiryDate: '01-DEC-2026',
      storageCondition: 'Ambient',
      storageLocation: 'Hyderabad, Telangana, India',
    },
    {
      campaignBatch: 'TYR12345 / 400684',
      actualProductQuantity: '782',
      expectedProductQuantity: '800',
      uom: 'KG',
      yield: '98.75%',
      batchManufacturingDate: '01-AUG-2024',
      expiryDate: '01-DEC-2026',
      storageCondition: 'Ambient',
      storageLocation: 'Hyderabad, Telangana, India',
    },
  ];

  const cppData = [
    {
      campaignBatch: 'TYR12345 / 400682',
      parameter: 'Concentration',
      setPoint: '5',
      range: '4.2 - 6.0',
      actualValue: '5.4',
      uom: 'G/L',
    },
    {
      campaignBatch: 'TYR12345 / 400683',
      parameter: 'Concentration',
      setPoint: '6',
      range: '5.6 - 6.8',
      actualValue: '6.2',
      uom: 'G/L',
    },
    {
      campaignBatch: 'TYR12345 / 400684',
      parameter: 'Concentration',
      setPoint: '5',
      range: '4.4 - 6.1',
      actualValue: '5.9',
      uom: 'G/L',
    },
  ];

  const inProcessTestsData = [
    {
      campaignBatch: 'TYR12345 / 400682',
      procedureNumber: 'B.4.2',
      methodNumber: 'T.28.5.1',
      methodName: 'High Performance Liquid Chromatography',
      sampleID: 'K-252.9.4.1',
      sampleDescription: 'Presence Of Caffeine',
      specificationLimit: 'NMT 0.05%',
      analyticalReportNumber: 'AR123',
      resultValue: '0.03%',
      result: 'Pass',
      cqas: 'Yes',
      uom: 'KG',
    },
    {
      campaignBatch: 'TYR12345 / 400683',
      procedureNumber: 'B.4.2',
      methodNumber: 'T.31.2.1',
      methodName: 'By Product Analysis',
      sampleID: 'K-252.7.5.1',
      sampleDescription: 'Presence Of Butyl Acetate',
      specificationLimit: 'NMT 0.10%',
      analyticalReportNumber: 'AR456',
      resultValue: '0.06%',
      result: 'Pass',
      cqas: 'No',
      uom: 'KG',
    },
    {
      campaignBatch: 'TYR12345 / 400684',
      procedureNumber: 'B.4.2',
      methodNumber: 'T.22.3.9',
      methodName: 'Catalyst Activity Testing',
      sampleID: 'K-252.4.3.1',
      sampleDescription: 'Monitor Conversion Of Ethyl Acetate To Ethanol',
      specificationLimit: '≥ 90% Conversion',
      analyticalReportNumber: 'AR789',
      resultValue: '94%',
      result: 'Pass',
      cqas: 'No',
      uom: 'KG',
    },
  ];

  const informationOnlyTestsData = [
    {
      campaignBatch: 'TYR12345 / 400682',
      procedureNumber: 'B.4.2',
      methodNumber: 'T.73.2.9',
      methodName: 'Iodometric Analysis',
      sampleID: 'K-252.7.4.1',
      sampleDescription: 'Presence Of Ethanol',
      specificationLimit: 'NA',
      arNumber: 'AR123',
      resultValue: 'Ethanol Detected',
      result: 'NA',
      cqas: 'Yes',
    },
    {
      campaignBatch: 'TYR12345 / 400683',
      procedureNumber: 'B.4.2',
      methodNumber: 'T.2.5.1',
      methodName: 'Gas Chromatography',
      sampleID: 'K-252.9.3.1',
      sampleDescription: 'Seperates Volatile Compounds',
      specificationLimit: 'NA',
      arNumber: 'AR456',
      resultValue: 'Major Peaks At 5.2 Min; Purity - 97.8%',
      result: 'NA',
      cqas: 'No',
    },
    {
      campaignBatch: 'TYR12345 / 400684',
      procedureNumber: 'B.4.2',
      methodNumber: 'T.6.4.1',
      methodName: 'Sample Preparation',
      sampleID: 'K-252.8.3.9',
      sampleDescription: 'Proper Sample Preparation',
      specificationLimit: 'NA',
      arNumber: 'AR789',
      resultValue: 'Sample Prepared As Per SOP',
      result: 'NA',
      cqas: 'No',
    },
  ];

  const cycleTimeData = [
    {
      campaignBatch: 'TYR12345 / 400682',
      startProcedureNumber: 'B.1.1',
      endProcedureNumber: 'B.7.3',
      procedureNumber: 'B.1.1',
      procedureName: 'Preparation Phase',
      actualStartTime: '25-April-2025 14:40:00',
      actualEndTime: '26-April-2025 15:40:00',
      plannedCycleTime: '24:00:00',
      actualCycleTime: '25:00:00',
    },
    {
      campaignBatch: 'TYR12345 / 400682',
      startProcedureNumber: 'B.1.1',
      endProcedureNumber: 'B.7.3',
      procedureNumber: 'B.7.3',
      procedureName: 'Finish Phase',
      actualStartTime: '27-April-2025 09:20:00',
      actualEndTime: '28-April-2025 14:20:00',
      plannedCycleTime: '21:00:00',
      actualCycleTime: '29:00:00',
    },
    {
      campaignBatch: 'TYR12345 / 400683',
      startProcedureNumber: 'B.1.1',
      endProcedureNumber: 'B.7.3',
      procedureNumber: 'B.1.1',
      procedureName: 'Preparation Phase',
      actualStartTime: '25-April-2025 14:40:00',
      actualEndTime: '26-April-2025 15:40:00',
      plannedCycleTime: '24:00:00',
      actualCycleTime: '25:00:00',
    },
  ];

  // Fetch all project IDs on component mount (separate API, not filtered)
  useEffect(() => {
    const loadProjectIds = async () => {
      try {
        setLoading(true);
        const response = await fetchAllProjectIdsAPI();
        if (response?.status && response?.data) {
          setProjectsList(response.data);
          
          // Set default project to first one if not set
          if (!selectedProject && response.data.length > 0) {
            setSelectedProject(response.data[0]);
          }
        }
      } catch (error) {
        console.error('Error fetching project IDs:', error);
      } finally {
        setLoading(false);
      }
    };

    loadProjectIds();
  }, []);

  // Fetch stages when project is selected
  useEffect(() => {
    if (!selectedProject) {
      setStagesList([]);
      setCampaignsList([]);
      setSelectedStage('');
      setSelectedCampaign('');
      return;
    }

    const loadStages = async () => {
      try {
        const response = await fetchStagesForProjectAPI(selectedProject);
        if (response?.status && response?.data) {
          setStagesList(response.data);
          
          // Set default stage to first one if not set
          if (response.data.length > 0 && (!selectedStage || !response.data.includes(selectedStage))) {
            setSelectedStage(response.data[0]);
          }
        }
      } catch (error) {
        console.error('Error fetching stages:', error);
        setStagesList([]);
      }
    };

    loadStages();
  }, [selectedProject]);

  // Fetch campaigns when project and stage are selected
  useEffect(() => {
    if (!selectedProject || !selectedStage) {
      setCampaignsList([]);
      setSelectedCampaign('');
      return;
    }

    const loadCampaigns = async () => {
      try {
        const response = await fetchCampaignsForProjectAPI(selectedProject, selectedStage);
        if (response?.status && response?.data) {
          setCampaignsList(response.data);
          
          // Set default campaign to first one if not set
          if (response.data.length > 0 && (!selectedCampaign || !response.data.includes(selectedCampaign))) {
            setSelectedCampaign(response.data[0]);
          }
        }
      } catch (error) {
        console.error('Error fetching campaigns:', error);
        setCampaignsList([]);
      }
    };

    loadCampaigns();
  }, [selectedProject, selectedStage]);

  // Fetch tabs when project, stage, and campaign are selected
  useEffect(() => {
    if (!selectedProject || !selectedStage || !selectedCampaign) {
      setTabsData([]);
      return;
    }

    const loadTabs = async () => {
      try {
        setLoadingTabs(true);
        // Extract campaign ID from "CampaignID / BatchNumber" format
        const campaignId = selectedCampaign.split(' / ')[0];
        const batchNumber = selectedCampaign.split(' / ')[1];
        
        const response = await fetchProjectAnalyticsTabsAPI(selectedProject, selectedStage, campaignId);
        if (response?.status && response?.data?.tabs) {
          setTabsData(response.data.tabs);
          
          // Initialize table data with rows from tabs (static data)
          const initialTableData = {};
          response.data.tabs.forEach(tab => {
            if (tab.rows && tab.rows.length > 0) {
              initialTableData[tab.id] = tab.rows;
            }
          });
          setTabTableData(initialTableData);
          
          // Initialize filter values for tabs that have filters
          const initialFilters = {};
          response.data.tabs.forEach(tab => {
            if (tab.hasFilters && tab.filters) {
              tab.filters.forEach(filter => {
                if (!initialFilters[tab.id]) {
                  initialFilters[tab.id] = {};
                }
                initialFilters[tab.id][filter.field] = filter.defaultValue || '';
              });
            }
          });
          setTabFilters(initialFilters);
        }
      } catch (error) {
        console.error('Error fetching tabs:', error);
        setTabsData([]);
      } finally {
        setLoadingTabs(false);
      }
    };

    loadTabs();
  }, [selectedProject, selectedStage, selectedCampaign]);

  // Fetch table data when tab changes or filters change
  useEffect(() => {
    if (!selectedProject || !selectedStage || !selectedCampaign || tabsData.length === 0) {
      return;
    }

    const currentTab = tabsData[tabValue];
    if (!currentTab) return;

    const loadTabData = async () => {
      try {
        const campaignId = selectedCampaign.split(' / ')[0];
        const filters = tabFilters[currentTab.id] || {};
        
        const response = await fetchProjectAnalyticsDataAPI(
          selectedProject,
          selectedStage,
          campaignId,
          currentTab.id,
          filters
        );
        
        if (response?.status && response?.data) {
          setTabTableData(prev => ({
            ...prev,
            [currentTab.id]: response.data.rows || []
          }));
        }
      } catch (error) {
        console.error('Error fetching tab data:', error);
      }
    };

    loadTabData();
  }, [selectedProject, selectedStage, selectedCampaign, tabValue, tabFilters, tabsData]);

  const handleBack = () => {
    history.goBack();
  };

  const handleSearch = (e) => {
    if (e) {
      e.preventDefault();
    }
    console.log('Search clicked with value:', searchValue);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleTabFilterChange = (tabId, filterField, value) => {
    setTabFilters(prev => ({
      ...prev,
      [tabId]: {
        ...prev[tabId],
        [filterField]: value,
      },
    }));
  };

  const handleRefresh = () => {
    setLastSyncTime(new Date());
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  const formatDateTime = (date) => {
    return moment(date).format('DD-MMM-YYYY HH:mm:ss');
  };

  const handleBatchGenealogy = () => {
    // Navigate to Batch Genealogy using the same URL pattern as other Project Development routes
    history.push(
      `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/manufacturingcollaboration/batch-genealogy`
    );
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(batchYieldData.length / rowsPerPage);
  const paginatedBatchYieldData = batchYieldData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div className={classes.headerLeft}>
          <div className={classes.backButton} onClick={handleBack}>
            <ChevronLeftIcon />
            <Typography variant="body1">Back</Typography>
          </div>
          <Typography className={classes.title}>Project Analytics</Typography>
        </div>
        <Button
          variant="contained"
          className={classes.batchGenealogyButton}
          onClick={handleBatchGenealogy}
        >
          Batch Genealogy
        </Button>
      </div>

      <div className={classes.filterSection}>
        <Grid container spacing={2} className={classes.filterRow}>
          <Grid item>
            <FormControl variant="outlined" size="small" className={classes.filterControl}>
              <Typography className={classes.dropdownLabel} gutterBottom>
                Select Project ID
              </Typography>
              <Select
                value={selectedProject}
                onChange={(e) => setSelectedProject(e.target.value)}
                disabled={loading || projectsList.length === 0}
                displayEmpty
              >
                {loading ? (
                  <MenuItem value="" disabled>Loading...</MenuItem>
                ) : projectsList.length === 0 ? (
                  <MenuItem value="" disabled>No projects available</MenuItem>
                ) : (
                  projectsList.map((project) => (
                    <MenuItem key={project} value={project}>
                      {project}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl variant="outlined" size="small" className={classes.filterControl}>
              <Typography className={classes.dropdownLabel} gutterBottom>
                Select Stage
              </Typography>
              <Select
                value={selectedStage}
                onChange={(e) => setSelectedStage(e.target.value)}
                disabled={!selectedProject || stagesList.length === 0}
                displayEmpty
              >
                {!selectedProject ? (
                  <MenuItem value="" disabled>Select project first</MenuItem>
                ) : stagesList.length === 0 ? (
                  <MenuItem value="" disabled>No stages available</MenuItem>
                ) : (
                  stagesList.map((stage) => (
                    <MenuItem key={stage} value={stage}>
                      {stage}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl variant="outlined" size="small" className={classes.filterControlLarge}>
              <Typography className={classes.dropdownLabel} gutterBottom>
                Select Campaign ID / Batch
              </Typography>
              <Select
                value={selectedCampaign}
                onChange={(e) => setSelectedCampaign(e.target.value)}
                disabled={!selectedProject || campaignsList.length === 0}
                displayEmpty
              >
                {!selectedProject ? (
                  <MenuItem value="" disabled>Select project first</MenuItem>
                ) : campaignsList.length === 0 ? (
                  <MenuItem value="" disabled>No campaigns available</MenuItem>
                ) : (
                  campaignsList.map((campaign) => (
                    <MenuItem key={campaign} value={campaign}>
                      {campaign}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </div>

      <div className={classes.searchAndSyncRow}>
        <div className={classes.filterLeft}>
          <Typography className={classes.filterByLabel}>Filter by:</Typography>
          <div className={classes.searchContainer}>
            <TextField
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
              placeholder="Search using Project ID, PO or Batch"
              className={classes.searchInput}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon style={{ color: "#666", marginRight: "8px" }} />
                  </InputAdornment>
                ),
              }}
            />
            <Button
              variant="contained"
              className={classes.searchButton}
              onClick={handleSearch}
            >
              Search
            </Button>
          </div>
        </div>
        <div className={classes.filterRight}>
          <div className={classes.refreshContainer}>
            <Typography variant="caption" className={classes.padR20}>
              {`Last synced @ ${formatDateTime(lastSyncTime)}`}
            </Typography>
            <Typography
              variant="caption"
              color="primary"
              className={classes.refreshText}
              onClick={handleRefresh}
            >
              Refresh
              <Cached color="primary" style={{ fontSize: 15 }} />
            </Typography>
          </div>
          <div className={classes.perPageContainer}>
            <Typography variant="body2" className={classes.hgText}>
              PER PAGE
            </Typography>
            <FormControl className={classes.formPerPage} variant="outlined">
              <Select
                labelId="perpage-filter"
                id="perpage-filter-id"
                value={rowsPerPage}
                onChange={handleRowsPerPageChange}
                style={{ outline: 'none' }}
                onFocus={(e) => e.target.style.outline = 'none'}
                classes={{
                  outlined: classes.outlined,
                }}
              >
                {[10, 25, 50].map((rows) => (
                  <MenuItem key={rows} value={rows}>
                    {rows}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
      </div>

      <div className={classes.tabsContainer}>
        <AppBar position="static" color="default" elevation={0}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="project analytics tabs"
            className={classes.tabs}
          >
            {loadingTabs ? (
              <Tab label="Loading..." className={classes.tab} disabled />
            ) : tabsData.length > 0 ? (
              tabsData.map((tab, index) => (
                <Tab key={tab.id} label={tab.name} className={classes.tab} />
              ))
            ) : (
              // Fallback static tabs if no tabs from API
              <>
                <Tab label="Batch Yield" className={classes.tab} />
                <Tab label="CPPs" className={classes.tab} />
                <Tab label="In-Process Tests" className={classes.tab} />
                <Tab label="Information Only Tests" className={classes.tab} />
                <Tab label="Cycle Time" className={classes.tab} />
              </>
            )}
          </Tabs>
        </AppBar>

        <div className={classes.tabPanelsContainer}>
          {loadingTabs ? (
            <TabPanel value={tabValue} index={0} className={classes.tabPanel}>
              <Typography>Loading tabs...</Typography>
            </TabPanel>
          ) : tabsData.length > 0 ? (
            // Render tabs from API
            tabsData.map((tab, index) => (
              <TabPanel key={tab.id} value={tabValue} index={index} className={classes.tabPanel}>
                {/* Render filters if tab has filters */}
                {tab.hasFilters && tab.filters && (
                  <Box style={{ marginBottom: '16px', display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
                    {tab.filters.map((filter) => {
                      if (filter.type === 'dropdown') {
                        return (
                          <FormControl key={filter.field} variant="outlined" size="small" style={{ minWidth: '150px' }}>
                            <Select
                              value={tabFilters[tab.id]?.[filter.field] || filter.defaultValue || ''}
                              onChange={(e) => handleTabFilterChange(tab.id, filter.field, e.target.value)}
                              displayEmpty
                            >
                              {filter.options.map((option) => (
                                <MenuItem key={option} value={option}>
                                  {option}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        );
                      } else if (filter.type === 'radio') {
                        return (
                          <RadioGroup
                            key={filter.field}
                            row
                            value={tabFilters[tab.id]?.[filter.field] || filter.defaultValue || ''}
                            onChange={(e) => handleTabFilterChange(tab.id, filter.field, e.target.value)}
                          >
                            {filter.options.map((option) => (
                              <FormControlLabel
                                key={option.value}
                                value={option.value}
                                control={<Radio />}
                                label={option.label}
                              />
                            ))}
                          </RadioGroup>
                        );
                      }
                      return null;
                    })}
                  </Box>
                )}
                
                {/* Render table */}
                <TableContainer component={Paper}>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        {tab.columns.map((column) => (
                          <TableCell key={column.id} className={classes.headerCell}>
                            {column.name}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(tabTableData[tab.id] || []).length > 0 ? (
                        tabTableData[tab.id].map((row, rowIndex) => (
                          <TableRow key={rowIndex}>
                            {tab.columns.map((column) => (
                              <TableCell key={column.id} className={classes.tableCell}>
                                {row[column.field] || '-'}
                              </TableCell>
                            ))}
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={tab.columns.length} style={{ textAlign: 'center', padding: '20px' }}>
                            No data available
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                <div className={classes.paginationContainer}>
                  <PaginationInput
                    totalPages={totalPages}
                    handlePageChange={handlePageChange}
                    page={currentPage}
                  />
                </div>
              </TabPanel>
            ))
          ) : (
            // Fallback static tab content if no tabs from API
            <TabPanel value={tabValue} index={0} className={classes.tabPanel}>
              <TableContainer component={Paper}>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.headerCell}>Campaign / Batch</TableCell>
                      <TableCell className={classes.headerCell}>Actual Product Qty</TableCell>
                      <TableCell className={classes.headerCell}>Expected Product Qty</TableCell>
                      <TableCell className={classes.headerCell}>UOM</TableCell>
                      <TableCell className={classes.headerCell}>Yield</TableCell>
                      <TableCell className={classes.headerCell}>Batch Mfg Date</TableCell>
                      <TableCell className={classes.headerCell}>Expiry Date</TableCell>
                      <TableCell className={classes.headerCell}>Storage Condition</TableCell>
                      <TableCell className={classes.headerCell}>Storage Location</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedBatchYieldData.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>{row.campaignBatch}</TableCell>
                        <TableCell className={classes.tableCell}>{row.actualProductQuantity}</TableCell>
                        <TableCell className={classes.tableCell}>{row.expectedProductQuantity}</TableCell>
                        <TableCell className={classes.tableCell}>{row.uom}</TableCell>
                        <TableCell className={classes.tableCell}>{row.yield}</TableCell>
                        <TableCell className={classes.tableCell}>{row.batchManufacturingDate}</TableCell>
                        <TableCell className={classes.tableCell}>{row.expiryDate}</TableCell>
                        <TableCell className={classes.tableCell}>{row.storageCondition}</TableCell>
                        <TableCell className={classes.tableCell}>{row.storageLocation}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <div className={classes.paginationContainer}>
                <PaginationInput
                  totalPages={totalPages}
                  handlePageChange={handlePageChange}
                  page={currentPage}
                />
              </div>
            </TabPanel>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectAnalytics;


